'use client';

import * as React from 'react';

import { useTheme } from 'next-themes';

import { cn } from '@/utils/app.utils';

import IconButton from './buttons/IconButton';
import NextIcon from './NextIcon';

type Props = {
  className?: string;
};
const ToggleTheme = ({ className }: Props) => {
  const { theme, setTheme } = useTheme();

  return (
    <IconButton
      className={cn(
        'relative rounded-md border !border-gray-100 p-2 dark:!border-secondary-dark',
        className
      )}
      onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
    >
      <NextIcon
        alt=""
        aria-hidden="true"
        className="rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0"
        size={19}
        src="/icons/sun.svg"
      />
      <NextIcon
        alt=""
        aria-hidden="true"
        className="absolute left-[5px] top-[5px] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100"
        size={24}
        src="/icons/moon.svg"
      />

      <span className="sr-only">Toggle theme</span>
    </IconButton>
  );
};

export default ToggleTheme;
